<script setup lang="ts">
import { isHideCombosActiveKey } from '~/lib/interfaces/symbols'
import { ProductEcommerceLite } from '~/lib/services/store/catalog/catalog.dtos'

const props = defineProps<{
  product: ProductEcommerceLite
}>()

const isMobile = inject<Ref<boolean>>('isMobile')
const emit = defineEmits(['add-suggestive'])
const { format } = useFormatAmount()
const isHideCombosActive = inject(isHideCombosActiveKey)!

const productPrice = computed(() => {
  const amount = props.product.price.amount || props.product.unifiedPrice?.amount || 0
  return format(amount)
})

const productName = computed(() => {
  if (isHideCombosActive.value) {
    return props.product.genericName ?? props.product.name
  }
  return props.product.name
})
</script>

<template>
  <div
    v-if="isMobile"
    class="flex w-32 cursor-pointer flex-col gap-4"
    @click="emit('add-suggestive')"
  >
    <div
      class="flex h-32 w-fit items-center justify-center rounded-lg bg-mcd-secondaryIvory px-2 py-4 shadow-suggestive-down"
    >
      <ImageResolver
        :url="product.imageUrl"
        :alt="`${productName} image`"
        class="h-full w-full object-cover"
        loading="lazy"
      />
    </div>

    <div class="flex h-full flex-1 flex-col justify-between gap-1 text-xs">
      <p class="line-clamp-2">{{ productName }}</p>
      <p class="font-bold">{{ productPrice }}</p>
    </div>
  </div>

  <div
    v-else
    class="flex w-[8.65rem] cursor-pointer flex-col rounded-lg shadow-suggestive-down"
    @click="emit('add-suggestive')"
  >
    <div class="flex h-[8.65rem] w-fit items-center justify-center bg-mcd-secondaryIvory">
      <ImageResolver
        :url="product.imageUrl"
        :alt="`${productName} image`"
        class="h-full w-full object-cover"
        loading="lazy"
      />
    </div>

    <div class="flex h-[88px] flex-col justify-start gap-2 p-4 text-xs">
      <p class="line-clamp-2">{{ productName }}</p>
      <p class="font-bold">{{ productPrice }}</p>
    </div>
  </div>
</template>
